<template>
  <tr class="marketing-credits-list-item">
    <td>
      {{ item.description }}
    </td>

    <td>
      {{ date }}
    </td>

    <td :class="`marketing-credits-list-item-amount ${isPositiveAmount ? 'marketing-credits-list-item-amount_positive': ''}`">
      {{ item.amount }}
    </td>

    <td>
      {{ expirationDate }}
    </td>
  </tr>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    item: {
      type: Object,
    },
  },

  created() {},

  computed: {
    extraData() {
      return JSON.parse(this.item.extraData);
    },
    date() {
      return this.$date.format(this.item.date);
    },
    expirationDate() {
      return this.extraData.expirationDate
        ? this.$date.format(this.extraData.expirationDate)
        : "-";
    },
    isPositiveAmount() {
      return this.item.amount > 0;
    },
  },

  watch: {},

  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-credits-list-item {
  .marketing-credits-list-item-amount {
    color: $danger;

    &.marketing-credits-list-item-amount_positive {
      color: $success;
    }
  }
}
</style>
